import Register from '../../components/Register'

export const RegisterPage =()=><Register/>

export default RegisterPage